export const RM = (v) =>
  "RM " + Number(v || 0).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const RMcompact = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1_000_000) return "RM " + (n / 1_000_000).toFixed(2) + "M";
  if (Math.abs(n) >= 1_000) return "RM " + (n / 1_000).toFixed(1) + "K";
  return "RM " + n.toFixed(0);
};

export const MONTHS = ["", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
